import script from "./G703TemplateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./G703TemplateModal.vue?vue&type=script&setup=true&lang=js"

import "./G703TemplateModal.vue?vue&type=style&index=0&id=7fedd302&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fedd302"]])

export default __exports__